<script setup lang="ts">
defineProps<{
  label: string;
  icon: string;
  dependentsNumber?: number;
}>();
</script>

<template>
  <button
    type="button"
    tabindex="-1"
    class="bg-blue-100 h-9 px-2 text-sm font-normal rounded-md border-2 border-blue-200 text-blue-500 md:font-semibold"
    @click="$emit('onClick')">
    <hfc-icon :icon="['fas', icon]" /> {{ label }} <span v-if="dependentsNumber && dependentsNumber > 0">({{ dependentsNumber }})</span>
  </button>
</template>
